<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6683 10.1648H6.34788C5.83755 10.1648 5.4248 9.75209 5.4248 9.24176V5.08396C5.4248 2.83165 7.25645 1 9.50876 1C11.7611 1 13.5927 2.83165 13.5927 5.08396V9.24176C13.5927 9.75209 13.18 10.1648 12.6696 10.1648H12.6683ZM7.26964 8.31868H11.7452V5.08396C11.7452 3.84967 10.7417 2.84615 9.50744 2.84615C8.27316 2.84615 7.26964 3.84967 7.26964 5.08396V8.31868Z"
      fill="currentColor"
    />
    <path
      d="M14.2642 7.26367H4.75253C3.78462 7.26367 3 8.04829 3 9.0162V17.2474C3 18.2153 3.78462 18.9999 4.75253 18.9999H14.2642C15.2321 18.9999 16.0167 18.2153 16.0167 17.2474V9.0162C16.0167 8.04829 15.2321 7.26367 14.2642 7.26367ZM10.6259 15.1283C10.6985 15.3775 10.5112 15.6267 10.2514 15.6267H8.76396C8.50418 15.6267 8.31692 15.3775 8.38945 15.1283L8.94066 13.2399C8.47121 13.025 8.14418 12.5516 8.14418 12.0004C8.14418 11.2474 8.75472 10.6369 9.50769 10.6369C10.2607 10.6369 10.8712 11.2474 10.8712 12.0004C10.8712 12.5516 10.5442 13.025 10.0747 13.2399L10.6259 15.1283Z"
      fill="currentColor"
    />
  </svg>
</template>
